import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
  root: {
    marginBottom: 25,
  },
  formControl: {
    width: '100%',
  },
}))

export default useStyles
